var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "phonebook-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-address-book",
            backPath: "/parameters/phonebooks",
          },
        },
        [
          !_vm.editMode
            ? _c("h1", [
                _c("span", [_vm._v(_vm._s(_vm.$t("phonebook.titles.new")))]),
                _vm._v(" "),
                _vm.namePhonebook ? _c("span", [_vm._v('"')]) : _vm._e(),
                _c("span", { staticStyle: { "font-weight": "900" } }, [
                  _vm._v(_vm._s(_vm.namePhonebook)),
                ]),
                _vm.namePhonebook ? _c("span", [_vm._v('"')]) : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode
            ? _c("h1", [_vm._v(_vm._s(_vm.namePhonebook))])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-xl-4 mb-4" },
          [
            _c("UiCard", [
              _c("form", [
                _c("h2", { staticClass: "mt-0" }, [
                  _c("i", { staticClass: "fa fa-address-book" }),
                  _vm._v(_vm._s(_vm.$t("phonebook.phonebook"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row row mb-0" }, [
                  _c("label", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.$t("phonebook.cols.namePhonebook"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.namePhonebook,
                        expression: "namePhonebook",
                      },
                    ],
                    staticClass: "form-input col",
                    attrs: { type: "text" },
                    domProps: { value: _vm.namePhonebook },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.namePhonebook = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-xl-8 full-height mb-4" },
          [
            _c("UiCard", [
              _c("form", [
                _c("h2", { staticClass: "mt-0" }, [
                  _c("i", { staticClass: "fa fa-users" }),
                  _vm._v(_vm._s(_vm.$t("phonebook.contacts"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c("SuperTable", {
                      attrs: {
                        tableColumns: _vm.tableColumns,
                        tableData: _vm.tableData,
                        options: _vm.sortableOptions,
                      },
                      on: {
                        endDrag: _vm.onEndDrag,
                        rowEdit: _vm.onEditAction,
                        rowDelete: _vm.onDeleteAction,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "can",
                        rawName: "v-can",
                        value: "beepiz-edit-phonebooks",
                        expression: "'beepiz-edit-phonebooks'",
                      },
                    ],
                    staticClass: "d-flex gap-2",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameContact,
                          expression: "nameContact",
                        },
                      ],
                      staticClass: "form-input flex-1",
                      attrs: {
                        type: "text",
                        maxlength: "64",
                        placeholder: _vm.$t("phonebook.cols.contactName"),
                      },
                      domProps: { value: _vm.nameContact },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nameContact = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phoneContact,
                          expression: "phoneContact",
                        },
                        {
                          name: "inputmask",
                          rawName: "v-inputmask",
                          value: { regex: "[\\+0]?[0-9]{2,14}" },
                          expression: "{regex: '[\\\\+0]?[0-9]{2,14}'}",
                        },
                      ],
                      staticClass: "form-input flex-1",
                      attrs: {
                        type: "text",
                        name: "phoneContact",
                        maxlength: "14",
                        placeholder: _vm.$t("phonebook.cols.phoneNumber"),
                      },
                      domProps: { value: _vm.phoneContact },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phoneContact = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.showErrors["phoneContact"] &&
                              _vm.errors.has("phoneContact"),
                            expression:
                              "!showErrors['phoneContact'] && errors.has('phoneContact')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("phoneContact")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("phoneContact")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "Btn",
                      {
                        staticClass: "icon",
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.clearContactForm($event)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "Btn",
                      {
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addOrEditContact($event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.contactFormBtnLabel))]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "justify-content-end pt-0" },
        [
          _c(
            "Btn",
            [
              _c(
                "router-link",
                { attrs: { to: "/parameters/phonebooks", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-phonebooks",
                  expression: "'beepiz-edit-phonebooks'",
                },
              ],
              staticClass: "primary",
              class: !!this.namePhonebook ? "" : "disabled",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.validForm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }